export default [
    {
        path: 'relatorio-quantitativo-producao',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-quantitativo-producao' */
            '@/views/exame-laboratorial/relatorio-quantitativo-producao/Index'
        ),
        redirect: 'relatorio-quantitativo-producao/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-quantitativo-producao-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-quantitativo-producao' */
                    '@/views/exame-laboratorial/relatorio-quantitativo-producao/List.vue'
                ),
            },
        ],
    }
]